export default "__VITE_ASSET__6683ad12__"